import RequestManager from './../../requests/RequestManager';
import FiltersTask from './../../requests/tasks/epg/FiltersTask';
import epgCache from '../../utils/EpgCache';
import Device from '../../devices/device';
import store from '../../store';
import ActivesSingleton from '../Header/ActivesSingleton';
import settings from '../../devices/all/settings';
import Metadata from '../../requests/apa/Metadata';
import ChannelStreamUtil from '../../utils/ChannelStreamUtil';
import { fetchLinealChannels } from '../../actions/payway';
import LocalStorage from '../DeviceStorage/LocalStorage';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import Utils from '../../utils/Utils'
import EpgLineUp from '../../requests/tasks/epg/EpgLineUp';
import EpgConstants from '../../AAF/Nepg/EpgConstants';
import FastPlayChannelsTask from './../../requests/tasks/player/FastPlayChannelsTask';
import { DASH_CMAF, DASHWV } from 'src/utils/playerConstants';
import AAF from "../../AAF/AAF"
import { EPG_VERSION_TTL, LINEAL_CHANNELS_TTL } from "../../AAF/Resilence/TTLConstants";
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import logger from 'src/utils/logger/logger';


const TTLItemEV = EPG_VERSION_TTL;
const TTLItemLC = LINEAL_CHANNELS_TTL;
const lineupRequest = async (instance, userStatus, nodeId, resolve) => {

  /////////// REQUEST LINEUP ///////////////
  logger.debug("@@@ lineup TV REQUEST")
  /*let nodes = JSON.parse(Metadata.get('links_nav_configuration', '{}'));
  const region = DeviceStorage.getItem('region');
  var nodoTV = nodes[region] ? nodes[region].clarotv : nodes['default'].clarotv;*/

  const nodoTV = Utils.getApaMetadataKey('links_nav_configuration', '{}', 'clarotv')
  var isCurrentNodoTV = nodoTV === instance.node ? true : false;
  AAF.TTLUtil.verifyTTLItem(TTLItemEV, () => { AAF.TTLUtil.setEpgVersion(); }, 'ChannelSingleton[lineupRequest]');

  try {
    const level_params = {
      node: instance.node,
      user_status: userStatus,
      node_id: nodeId,
      isCurrentNodoTV: isCurrentNodoTV,
      epg_version: LocalStorage.getItem('epgVersion') || false,
      soa_version: LocalStorage.getItem('soaVersion') || false
    };
    const task = new EpgLineUp(level_params);

    const response = await RequestManager.addRequest(task)
    let channels = (response && response.response && response.response.channels) || [];
    channels = Utils.mapToLineUp(channels) || [];
    instance._channels = await buildChannels(channels);
    instance.gettingData = false;
    if (resolve) resolve(instance.getChannels());
    getAllFilterData(instance);

    logger.debug("@@@ ChannelStreamUtil.__elements:", ChannelStreamUtil.__elements);

  } catch (e) {
    logger.error('@@@ [ChannelsSingleton] lineupRequest err', e);
  }
};

const   buildChannels = async (channels = [], fastPlayChannels = null) => {
  if (!fastPlayChannels) {
    fastPlayChannels = await instance.getFastPlayChannels(channels);
  }

  return channels.map(channel => {
    if (channel.encodes && channel.encodes.length > 0) {
      // Se usa live_url, porque channel_url siempre viene en null y para no alterar esa lógica

      // Sólo para pruebas Netflix y Amazon
      // if(783831 === parseInt(channel.group_id)) {
      //   logger.debug('[NTX] Channel live_url hay netflix');
      //   channel.fast_play.external_app = 'urn://com.netflix.ninja';
      // }

      // if(783832 === parseInt(channel.group_id)) {
      //   logger.debug('[NTX] Channel live_url hay amazon');
      //   channel.fast_play.external_app = 'urn://com.amazon.prime';
      // }

      // Check for external_app
      let live_url = channel.live_url;
      if(channel.fast_play && Utils.isNotNullOrNotUndefined(channel.fast_play.external_app)) {
        live_url = channel.fast_play.external_app;
      }

      const fastPlay = getFastPlayForChannel(channel, fastPlayChannels);

      ChannelStreamUtil.set(channel.group_id, {
        tpa_app: '',
        encodes: channel.encodes,
        live_url,
        fast_play: fastPlay,
        proveedor: channel.proveedor,
        title: channel.title || '',
        group_id: channel.group_id || null,
        cover: channel.cover || '',
        channel_number: channel.id ? channel.id : null,
        background: channel.background,
        imageEpg: channel.imageEpg || null,
        channel_number: channel.channel_number || null,
        // TODO ajustar esto
        rating: {
          id: channel.rating_id ? channel.rating_id : null, // ej.: 10
          code: channel.rating ? channel.rating : null
          // ej.: 'G'
        },
        id: channel.id || '',
        audio: channel.audio ? channel.audio : null,
        subtitle: channel.subtitle ? channel.subtitle : null,
        live_enabled: channel.live_enabled || null,
        image_small: channel.image_small ? channel.image_small : null,
        npvr: ChannelSingleton.getNpvrStorage(channel.group_id) > 0 ? true : false // NpvrStorage de linealChannels para saber si el canal tiene permisos de grabacion
      });
    }

    // Se usa persistencia de imágenes en storage para todos los dispositivos.
    if (channel && channel.imageEpg) {
      try {
        new Image().src = channel.imageEpg;
      } catch (error) {}
    }
    return {
      channel_url: channel.channel_url ? channel.channel_url : 'tv://channel.00a0002a0002',
      cover: channel.cover,
      imageEpg: channel.imageEpg ? channel.imageEpg : null,
      title: channel.title,
      group_id: channel.group_id,
      id: channel.id,
      live_enabled: channel.live_enabled ? channel.live_enabled : null,
      channel_number: channel.id ? channel.id : null,
      image_small: channel.image_small ? channel.image_small : null,
      provider: channel.provider, // Necesario para presentar modales de susc, en caso de
      timeshift: channel.timeshift ? channel.timeshift : null, // en horas
      encodes: channel.encodes
    };
  });
};

const getFastPlayForChannel = (channel, fastPlayChannels) => {
  const fastPlay = {...channel.fast_play};
  const fastPlayStreamTypes = fastPlayChannels
    .map(channelsGroup => ({
        fastPlayObject: channelsGroup.groups ? channelsGroup.groups.find(ch => ch.group_id === channel.group_id) : null,
        streamType: channelsGroup.streamType
      }))
    .filter(channelsGroup => channelsGroup.fastPlayObject !== null);

  fastPlayStreamTypes.forEach(channelsGroup => {
    fastPlay[channelsGroup.streamType] = channelsGroup.fastPlayObject;
  });
  return fastPlay;
}

const getAllFilterData = instance => {
  //let nodes = JSON.parse(Metadata.get('links_nav_configuration', '{}'));
  //const region = DeviceStorage.getItem('region');
  //var nodoTV = nodes[region] ? nodes[region].clarotv : nodes['default'].clarotv;
  const nodoTV = Utils.getApaMetadataKey('links_nav_configuration', '{}', 'clarotv')
  var isCurrentNodoTV = nodoTV === instance.node ? true : false;
  AAF.TTLUtil.verifyTTLItem(TTLItemEV, () => { AAF.TTLUtil.setEpgVersion(); }, 'ChannelSingleton[getAllFilterData]');

  return new Promise((resolve, reject) => {
    try {
      instance._allFilterData = {};
      const fastPlayChannels = instance._fastPlayChannels || [];
      instance.getFilters().then(filters => {
        filters.map((filter, index) => {
          if(filter && filter.isFavorite) return;
          const level_params = {
            node: instance.node,
            user_status: instance._userStatus,
            node_id: filter.id,
            isCurrentNodoTV: isCurrentNodoTV,
            epg_version: LocalStorage.getItem('epgVersion') || false,
            soa_version: LocalStorage.getItem('soaVersion') || false
          };
          const task = new EpgLineUp(level_params);
          RequestManager.addRequest(task).then(async response => {
            let channels = response && response.response && response.response.channels || [];
            channels = Utils.mapToLineUp(channels) || [];
            instance._allFilterData[`${filter.id}`] = await buildChannels(channels, fastPlayChannels);
            logger.debug('_allFilterData', instance._allFilterData);
            if (filters.length - 1 == index) {
              resolve(instance._allFilterData);
            }
          });
        });
      });
    } catch (error) {
      logger.error('[ChannelsSingleton] getAllFilters err', error);
    }
  });
};

const getData = (instance, userStatus, isFilter = false, resolve) => {
  if (instance.node == null) {
    instance._filters = [];
    instance._channels = [];
    resolve ? resolve([]) : null;
    instance.gettingData = false;
    return;
  }
  if (instance.gettingData) return;
  instance.gettingData = true;
  try {
    const task = new FiltersTask({});

    RequestManager.addRequest(task).then(response => {
      const filters = response.response.nodes;
      let defaultNodeId = null;
      instance._filters = [];
      if (filters) {
        instance._filters = filters.map(filter => {
          return {
            id: filter.id,
            code: filter.code,
            text: filter.text
          };
        });
        instance._filters.push({
          code: EpgConstants.FAV_CODE_ITEM,
          id: EpgConstants.FAV_ID_ITEM,
          text: "Favoritos",
          isFavorite: true
        });
        if (resolve && isFilter) resolve(instance.getFilters());
        defaultNodeId = instance._filters[0].id;
      }

      lineupRequest(instance, userStatus, defaultNodeId, resolve);
    });
  } catch (e) {
    logger.error('[ChannelsSingleton] getData err', e);
  }
};

const getMenu = async (instance) => {

  if (instance.node == null) {
    instance._filters = [];
    instance.gettingData = false;
    return new Promise(resolve => resolve(false));
  }
  try {
    const task = new FiltersTask({});
    const response = await RequestManager.addRequest(task);
    const filters = response.response.nodes;
    instance._filters = [];
    if (filters) {
      instance._filters = filters.map(filter => {
        return {
          id: filter.id,
          code: filter.code,
          text: filter.text
        };
      });
        instance._filters.push({
            code: EpgConstants.FAV_CODE_ITEM,
            id: EpgConstants.FAV_ID_ITEM,
            text: "Favoritos",
            isFavorite: true
        });
    }
    return new Promise(resolve => resolve(true));

  } catch (e) {
    return new Promise(resolve => resolve(false))
  }
}


const  reloadEpgMenu = async () => {
  const getMenuSuccess = await getMenu(instance)

  return new Promise((resolve, reject) => {
    if (getMenuSuccess){
      return resolve(true)
    } else {
      return reject(false);
    }
  });


}
const reloadEpgLineUp = async () => {
  try {
    getAllFilterData(instance);
    return new Promise((resolve, reject)=>{
      return resolve(true)
    })
  } catch (error){
    return new Promise((resolve, reject)=>{
      return resolve(false)
  })
}
}

const init = (instance, userStatus, nodes) => {
  instance._filters = null;
  instance._channels = null;
  instance._userStatus = userStatus;
  instance._allFilterData = {};
  instance.node = new ActivesSingleton().getTvNode();
  instance._fastPlayChannels = null;
  instance._fastPlayTimeout = null;
  instance._fastPlayStreamTypes = [DASH_CMAF, DASHWV];
  let navV = Metadata.get('nav_visibility', '{}');
  navV = JSON.parse(navV);
  navV = navV.filter(x => x.code == instance.node && x[userStatus] == '0');
  //TODO necesitamos una mejor forma de de ahcer esto
  nodes = nodes.filter(x => x.code == instance.node);
  if (navV.length > 0) {
    instance.node = null;
  }

  instance.getChannels = instance.getChannels.bind(instance);
};

let instance = null;
class ChannelSingleton {
  constructor(user, nodes = []) {
    if (user && nodes.length>0 ) {
      if(!instance){
        instance = this;
      }
      init(instance, user.userStatus, nodes);
      getData(instance, user.userStatus);
      const refreshSeconds = Utils.getApaMetadataKey('channel_settings', '{"time_refresh": 3600}','time_refresh');
      setInterval(() => {
        getData(this, user.userStatus);
      }, refreshSeconds * 1000);
    }
    if(!instance && !user && nodes.length === 0 ){
      instance = this;
    }
    return instance;
  }

  async getFastPlayChannels(channels) {
    const streamTypes = this._fastPlayStreamTypes;
    this.clearFastPlayTimeout();
    const fastPlayChannels = await this.fetchFastPlayChannels(channels, streamTypes);
    this.setFastPlayChannels(fastPlayChannels);
    const timeToRefresh = this.getFastPlayRefreshTime(fastPlayChannels);
    const timeout = timeToRefresh - Date.now();
    if (timeToRefresh) {
      this.setFastPlayTimeout(() => {
        this.refreshExpiredFastPlayChannels();
      }, timeout > 0 ? timeout : 0);
    }

    return fastPlayChannels;
  }

  clearFastPlayTimeout() {
    if (this._fastPlayTimeout) {
      clearTimeout(this._fastPlayTimeout);
      this._fastPlayTimeout = null;
    }
  }

  setFastPlayTimeout(func, time) {
    this._fastPlayTimeout = setTimeout(func, time);
  }

  setFastPlayChannels(fastPlayChannels) {
    this._fastPlayChannels = fastPlayChannels;
  }

  getFastPlayRefreshTime(fastPlayChannels) {
    const sec30 = 30 * 1000;
    let timeToRefresh = null;
    if(Array.isArray(fastPlayChannels) && fastPlayChannels.length > 0) {
      timeToRefresh = Math.min(...fastPlayChannels.map(group => group.exp)) * 1000 - sec30 ;
    }
    return timeToRefresh;
  }

  async refreshExpiredFastPlayChannels() {
    const channels = this._channels;
    const streamTypes = this._fastPlayStreamTypes;
    this.clearFastPlayTimeout();
    let fastPlayChannels = this._fastPlayChannels || [];

    // Filtramos los fastPlayChannels que todavía no expiraron
    const sec30 = 30 * 1000;
    const now = Date.now();
    const notExpiredFastPlayChannels = fastPlayChannels.filter(channelsGroup => channelsGroup.exp * 1000 - sec30 > now);
    const notExpiredStreamTypes = notExpiredFastPlayChannels.map(channelsGroup => channelsGroup.streamType);

    // Hacemos fetch de los canales con stream type que nos faltan
    const streamTypesToFecht = streamTypes.filter(streamType => !notExpiredStreamTypes.includes(streamType));
    const newFastPlayChannels = await this.fetchFastPlayChannels(channels, streamTypesToFecht);

    fastPlayChannels = [...notExpiredFastPlayChannels, ...newFastPlayChannels];

    this.setFastPlayChannels(fastPlayChannels);
    await buildChannels(channels, fastPlayChannels);

    // Refresh del fastplay token en player si se está reproduciendo el canal para evitar modal de error
    this.renewPlayingToken(newFastPlayChannels)

    // Se agenda próximo refresh de fastplay channels que van a expirar
    const timeToRefresh = this.getFastPlayRefreshTime(fastPlayChannels);
    const timeout = timeToRefresh - Date.now();
    if(timeToRefresh) {
      this.setFastPlayTimeout(() => {
        this.refreshExpiredFastPlayChannels();
      }, timeout > 0 ? timeout : 0);
    }

    return fastPlayChannels;
  }

  renewPlayingToken(newFastPlayChannels) {
    const playerOptions = AAFPlayer.getCurrentPlayerOptions()
    const pgm = AAFPlayer.pgm;
    const streamTypePlaying = pgm && pgm.media && pgm.media.streamType;
    const { islive, playerstate, streamContentType, source} = playerOptions;
    const videoId = source && source.videoid;
    const streamTypeToRenew = newFastPlayChannels.find(group => group.streamType === streamTypePlaying)
    const groupToRenew = streamTypeToRenew && streamTypeToRenew.groups && streamTypeToRenew.groups.find(group => group.group_id === videoId)
    if(
      videoId
      && islive
      && playerstate === 'PLAYING'
      && streamContentType === "content_is_tv"
      && groupToRenew
      ){
        const {challenge}  =  groupToRenew;
        logger.debug("#### Renewing token:", videoId, challenge)
        AAFPlayer.renewToken(challenge);
    }
  }

  doesChannelSupportFastPlay(channel, streamType) {
    const encodes = channel.encodes ||  [];
    const supportFastPlay = encodes.includes(streamType);
    return supportFastPlay
  }

  async fetchFastPlayChannels(channels = [], streamTypes = []) {
    const device = Device.getDevice().getPlatform();
    const supportedStreams = Utils.getApaSupportedStream(device, true).live;
    const streamTypesToFetch = streamTypes.filter(streamType => supportedStreams.includes(streamType));
    const user = await store.getState().user;

    // Se filtran groupsIds con permiso de reproducción (tienen paywayToken asociado)
    const groupIds = {};
    const paywayTokens = {};

    for(let channel = 0; channel < channels.length; channel++){
      if(this.doesChannelSupportFastPlay(channels[channel], streamTypesToFetch)) {
        let token;
        try {
          token = await instance.getPaywayToken(channels[channel].group_id);
        } catch (err) {
          logger.error("@@@ Error getting payway token for", channels[channel].group_id);
        }
        if(token) {
          groupIds.push(channels[channel].group_id);
          paywayTokens.push(token);
        }
      }
    }

    // for (const channel of [...channels]) {
    //   if(this.doesChannelSupportFastPlay(channel, streamTypesToFetch)) {
    //     let token;
    //     try {
    //       token = await instance.getPaywayToken(channel.group_id);
    //     } catch (err) {
    //       console.error("@@@ Error getting payway token for", channel.group_id);
    //     }
    //     if(token) {
    //       groupIds.push(channel.group_id);
    //       paywayTokens.push(token);
    //     }
    //   }
    // }

    // Se generan las tasks para cada streamType en fastPlay soportado por el dispositivo
    const tasks = streamTypesToFetch.filter(streamType => groupIds[streamType] && groupIds[streamType].length > 0).map(streamType => new FastPlayChannelsTask({
      groupIds: groupIds[streamType],
      paywayTokens: [...paywayTokens[streamType]],
      streamType,
      }));

    // Se obtienen las respuestas del servicio "assets"
    const responses = [];

    for(let task = 0; task < tasks.length; task++) {
      const streamType = streamTypesToFetch[task];
      try {
        const response = await RequestManager.addRequest(tasks[task]);
        responses.push({ ...response, streamType });
      } catch (err) {
        logger.error("@@@ Error fetching /services/player/assets for", streamType, err)
      }
    };

    return responses;
  }

  static hasTimeshiftAPA() {
    const configuration = Utils.getApaMetadataKey('timeshift_npvr_configuration', null, 'timeshift');

    if (configuration){
      return configuration.enable;
    }

    return false;
  }

  static getTimeshift(channelId, inSeconds = false) {
    // Verificar aquí si de inicio, esta metadata con timeshift habilitado

    //Se comenta solo para habilitar timeshift siempre, no tomando en cuenta la configuracion de APA
    //return 5 * 24 * 60 * 60;
    // TODO: Descomentar el IF para que funcione la configuracion de APA
    if (!ChannelSingleton.hasTimeshiftAPA()) {
      return 0;
    }

    const linealChannels = store.getState().linealChannels;
    if (Array.isArray(linealChannels)) {
      const channel = linealChannels.find(channel => channel.id == channelId);
      let timeshift = channel ? parseInt(channel.timeshift) : null;
      if (isNaN(timeshift)) {
        timeshift = 0;
      }

      //logger.debug('[STARTIME TIMESHIFT] ChannelSingleton.getTimeshift timeshift de linnealChannels ', timeshift);

      let opts = [];
      opts.push(timeshift);
      // En content/list, hay channels?
      let resultInMins = 0;
      if (instance && instance._channels && Array.isArray(instance._channels)) {
        const channelContentList = instance._channels.find(
          channel => channel.group_id == channelId
        );
        if (channelContentList) {
          const timeshiftContentList = channelContentList.timeshift
            ? channelContentList.timeshift
            : 0;
          //logger.debug('[STARTIME TIMESHIFT] ChannelSingleton.getTimeshift timeshift de timeshiftContentList ', timeshiftContentList);
          opts.push(timeshiftContentList);
          resultInMins = opts.reduce((x, y) => {
            return x < y ? x : y;
          });
          resultInMins = resultInMins * 60;
        }
      } else {
        // Default es lineal channels
        resultInMins = !isNaN(timeshift) ? timeshift * 60 : 0;
        //logger.debug('[STARTIME TIMESHIFT] entra en singleton ', resultInMins);
      }

      //console.error('[ChannelsSingleton] getTimeshift ', channelId, 'result: ', channel, 'timeshift ', timeshift, 'linealChannels', linealChannels, 'return in min', !isNaN(timeshift) ? timeshift * 60 : 0);
      /*
      console.info('[ChannelsSingleton] getTimeshift ', channelId,
        '\nresult: ', channel,
        '\ntimeshift ', timeshift,
        //'\nlinealChannels', linealChannels,
        '\nreturn in min', resultInMins);
        */
      return inSeconds ? 60 * resultInMins : resultInMins;
    }
    return 0;
  }

  static getNpvrStorage(channelId) {
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'ChannelSingleton[getNpvrStorage]');
    const linealChannels = store.getState().linealChannels;
    if (Array.isArray(linealChannels)) {
      const channel = linealChannels.find(channel => channel.id == channelId);
      this.getMaxNpvrStorage();
      const npvrStorage = channel ? parseInt(channel.npvrstorage) : null;
      const resultInMins = !isNaN(npvrStorage) ? npvrStorage * 60 : 0;
      return resultInMins;
    }
    return 0;
  }

  static getMaxNpvrStorage() {
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'ChannelSingleton[getMaxNpvrStorage]');
    const linealChannels = store.getState().linealChannels;
    let npvrStorageInMinutes = 0;
    if (Array.isArray(linealChannels)) {
      const channelsWithNpvrStorage = linealChannels.filter(
        channel => channel.npvrstorage != ''
      );
      if (channelsWithNpvrStorage.length != 0) {
        const maxNpvrStorage = linealChannels.reduce((prev, current) =>
          prev.npvrstorage > current.npvrstorage ? prev : current
        ).npvrstorage;
        npvrStorageInMinutes = !isNaN(maxNpvrStorage) ? maxNpvrStorage * 60 : 0;
      }
    }
    return npvrStorageInMinutes;
  }

  /*
      Revisar si un user tiene la suscripción al canal del group_id indicado
  */
  static canPlayChannel(group_id) {
    let channel = null;
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'ChannelSingleton[canPlayChannel]');
    const linealChannels = store.getState().linealChannels;
    if (Array.isArray(linealChannels)) {
      channel = linealChannels.find(tchannel => tchannel.id === group_id);
    }
    return channel && channel.play ? channel : false;
  }

  getFiltersTO(resolve, leftTimesLogging = 3) {
    if (Device.getDevice().getPlatform() === 'arris') {
      if (leftTimesLogging > 0) {
        logger.debug(
          '[ChannelsSingleton] getFilters: ' + leftTimesLogging + ' attempts remain'
        );
      }
    } else {
      // logger.debug('[ChannelsSingleton] getFilters');
    }
    setTimeout(
      (resolve => {
        if (this.gettingData) this.getFiltersTO(resolve, leftTimesLogging - 1);
        else {
          if(!this._filters){
            return this.getFiltersTO(resolve);
          }
          else
            resolve([...this._filters]);
        }
      }).bind(this),
      500,
      resolve
    );
  }

  getFilteredChannelsGroupIdsByNode(nodeId) {
    if (this._allFilterData) {
      return this._allFilterData[nodeId.id].map(filter => filter.group_id);
    }
    return null;
  }

  getFilters() {
    return new Promise(
      ((resolve, reject) => {
        if (this._filters) {
          resolve([...this._filters]);
        } else {
          this.getFiltersTO(resolve);
        }
      }).bind(this)
    );
  }

  getChannelTO(resolve, leftTimesLogging = 3) {
    if (Device.getDevice().getPlatform() === 'arris') {
      if (leftTimesLogging > 0) {
        logger.debug(
          '[ChannelsSingleton] getChannelTO: ' + leftTimesLogging + ' attempts remain'
        );
      }
    } else {
      // logger.debug('[ChannelsSingleton] getChannelTO');
    }
    setTimeout(
      (resolve => {
        if (this.gettingData) this.getChannelTO(resolve, leftTimesLogging - 1);
        else {
          // logger.debug('[ChannelsSingleton] getChannelTO resolve');
          if(!this._channels)
            this.getChannelTO(resolve);
          else resolve([...this._channels]);
        }
      }).bind(this),
      500,
      resolve
    );
  }

  getChannelsNow() {
    return this._channels;
  }

  getChannelByGroupIdNow(groupId) {
    if (!this._channels) {
      return null;
    }
    const index = this.getChannelsNow().findIndex(data => data.group_id == groupId);

    if (index == -1) {
      return null;
    }

    return this.getChannelsNow()[index];
  }

  getChannelByIdNow(Id) {
    if (!this._channels) {
      return null;
    }
    const index = this.getChannelsNow().findIndex(data => data.id == Id);

    if (index == -1) {
      return null;
    }

    return this.getChannelsNow()[index];
  }

  getChannels() {
    logger.debug('[ChannelsSingleton] getChannels');
    return new Promise(
      ((resolve, reject) => {
        if (this._channels) {
          resolve([...this._channels]);
        } else {
          this.getChannelTO(resolve);
        }
      }).bind(this)
    );
  }

  getFilteredChannelsByNode(nodeId) {
    if (this._allFilterData) {
      return this._allFilterData[nodeId];
    }
    return null;
  }

  getFilteredChannels(nodeId) {
    return new Promise((resolve, reject) => {
      if (this._allFilterData) {
        //logger.debug('[EPGFILTER] Singleton getFilteredChannels hay data ', this._allFilterData, nodeId);
        return resolve([...this._allFilterData[nodeId]]);
      } else {
        //logger.debug('[EPGFILTER] Singleton getFilteredChannels NO hay data');
        return getAllFilterData(this).then(() => {
          return resolve([...this._allFilterData[nodeId]]);
        });
      }
    });
  }

  getMaxTimeshift() {
    logger.debug('[GED] enter getMaxTimeshift');
    return new Promise((resolve, reject) => {
      this.getChannels().then(channels => {
        logger.debug('[GED] enter getMaxTimeshift');

        let maxTimeshift = 0;
        channels.forEach(ch => {
          const timeshift = ChannelSingleton.getTimeshift(ch.group_id);
          if (timeshift > maxTimeshift) maxTimeshift = timeshift;
        });

        logger.debug('[GED] enter getMaxTimeshift resolve ', maxTimeshift);

        //resolve(24 * 60); // para pruebas, un día hacía atrás en minutos
        // NOTA: Se regresan segundos
        resolve(maxTimeshift * 60);
      });
    });
  }

  getChannelByGroupId = async channelId => {
    try {
      const channels = await this.getChannels();
      logger.debug('dan 2: channel', channels, channelId);
      const channel = channels.find(channel => channel.group_id == channelId);
      logger.debug('dan 2: channel', channels, channelId);
      return Promise.resolve(channel);
    } catch (e) {
      logger.error('[ChannelSingleton] could not getChannel by id: ', channelId);
      return Promise.reject({});
    }
  };

  getTimeshiftToken = async channelId => {
    logger.debug('dan 1: channel', channelId);
    const channel = await this.getChannelByGroupId(channelId);
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'ChannelSingleton[getTimeshiftToken]');
    const linealChannels = store.getState().linealChannels;
    logger.debug('dan: linealChannels', linealChannels);
    logger.debug('dan: channel', channel);
    if (Array.isArray(linealChannels)) {
      const linealChannel = linealChannels.find(
        linealChannel => linealChannel.id == channel.group_id
      );
      logger.debug('dan: linealChannel', linealChannel);
      const paywayToken = linealChannel ? linealChannel.timeshift_token : '';
      return Promise.resolve(paywayToken);
    }
    return Promise.resolve('');
  };

  getPaywayToken = groupId => {
    logger.debug("getting paywayToken")
    AAF.TTLUtil.verifyTTLItem(TTLItemLC, () => { AAF.TTLUtil.setLinealChannels() }, 'ChannelSingleton[getPaywayToken]');
    const linealChannels = store.getState().linealChannels;
    logger.debug('dan: linealChannels', linealChannels);
    if (Array.isArray(linealChannels)) {
      const linealChannel = linealChannels.find(
        linealChannel => linealChannel.id === groupId
      );
      logger.debug('dan: linealChannel', linealChannel);
      const paywayToken = linealChannel ? linealChannel.npvr_token : '';
      return paywayToken;
    }
    return '';
  };

  /*
  Devuelve un array de canales que puede playear el usuario (registrado, anónimo, suscrito, linealchannels-based)
  */
  static getUserChannels() {
    let userChannels = [];
    const linealChannels = store.getState().linealChannels;
    if (Array.isArray(linealChannels)) {
      userChannels = linealChannels.filter(channel => channel.play);
    }

    return userChannels;
  }

  resetData = (cb = null) => {
    return new Promise(resolve=>{
      const user = store.getState().user;
      logger.debug('[ChannelSingleton] resetData user', user);
      getData(instance, user.userStatus, false, resolve);
      store.dispatch(fetchLinealChannels(user.user_id, cb));
      if (settings.epg_cache_enabled) {
        epgCache.clear();
      }
    });
  };

  reloadEpgMenuEpgLineUp = async () =>{
    try {
      let successReloadEpgLineUp = false;
      const successReloadEpgMenu  = await reloadEpgMenu();

      if (successReloadEpgMenu) {
        successReloadEpgLineUp = await reloadEpgLineUp().catch((err)=>{
        });
      }
      return new Promise((resolve) => {
        resolve(successReloadEpgLineUp);
      });
    } catch (ex) {
      return new Promise((resolve) => {
        resolve(false);
      });
    }


  }

  checkLinealChannels = cb => {
    const user = store.getState().user;
    store.dispatch(fetchLinealChannels(user.user_id, cb));
  };
}

export default ChannelSingleton;



// WEBPACK FOOTER //
// ./src/components/Epg/ChannelsSingleton.js